module.exports = __webpack_public_path__ + "static/media/Map.7a06d60f.png";